import React, { useState } from 'react';
import {
  Card,
  List,
  Rate,
  Select,
  Modal,
  Layout,
  Menu,
  Button,
  Popconfirm,
  Drawer,
  Input,
  Row,
  Col,
} from 'antd';
import {
  CaretDownOutlined,
  CaretUpOutlined,
  InfoCircleOutlined,
  FireOutlined,
  ToolOutlined,
  TagOutlined,
  CarOutlined,
  BarChartOutlined,
  AppstoreOutlined,
  LineChartOutlined,
  TableOutlined,
  LeftOutlined,
  RightOutlined,
  UserOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { Switch, Route, NavLink, useHistory } from 'react-router-dom';
import {
  BarChart,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ComposedChart,
  Area,
  Bar,
  Cell,
} from 'recharts';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import moment from 'moment';
import 'moment/locale/es';

import { formatterMetrico } from '../helpers/formatter';
import { colorArray } from '../helpers/const';
import { checkObjectKey } from '../helpers/cheks';

const { Search } = Input;
const { Option } = Select;
moment().locale('es');

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

function Metrico(props) {
  const history = useHistory();

  function dataYear() {
    let data = [];

    if (props.data.hasOwnProperty('resultsByYear')) {
      let emptyData = {};
      let dateStart = moment().startOf('year');
      let dateEnd = moment().endOf('year');

      while (dateEnd.diff(dateStart, 'month') >= 0) {
        emptyData[dateStart.format('M')] = null;
        dateStart.add(1, 'month');
      }

      let average = 0;
      for (let i = 0; i < props.data.resultsByYear.length; i++) {
        let item = props.data.resultsByYear[i];
        average += item.valor;
        emptyData[moment(item.registro, 'YYYY-MM-DD').format('M')] = item;
      }
      average = Math.floor(average / props.data.resultsByYear.length);

      for (const [key, value] of Object.entries(emptyData)) {
        data.push({
          name:
            moment(key, 'M').format('MMMM').charAt(0).toUpperCase() +
            moment(key, 'M').format('MMMM').slice(1),
          v: value ? value.valor : 0,
          t: average,
        });
      }
    }

    return data;
  }

  function dataMonth() {
    let data = [];

    if (props.data.hasOwnProperty('resultsByMonth')) {
      let emptyData = {};
      let dateStart = moment().startOf('month');
      let dateEnd = moment().endOf('month').subtract(24, 'hours');

      while (dateEnd.diff(dateStart, 'days') >= 0) {
        emptyData[dateStart.format('YYYY-MM-DD')] = null;
        dateStart.add(1, 'days');
      }

      let average = 0;

      for (let i = 0; i < props.data.resultsByMonth.length; i++) {
        let item = props.data.resultsByMonth[i];
        average += item.valor;
        emptyData[item.registro] = item;
      }
      average = Math.floor(average / props.data.resultsByMonth.length);

      for (const [key, value] of Object.entries(emptyData)) {
        data.push({
          name: moment(key, 'YYYY-MM-DD').format('D'),
          v: value ? value.valor : 0,
          t: average,
        });
      }
    }
    return data;
  }

  function dataWeek() {
    let data = [];
    let emptyData = {
      lunes: null,
      martes: null,
      miércoles: null,
      jueves: null,
      viernes: null,
      sábado: null,
      domingo: null,
    };
    if (props.data.hasOwnProperty('resultsByWeek')) {
      for (let i = 0; i < props.data.resultsByWeek.length; i++) {
        let item = props.data.resultsByWeek[i];
        emptyData[moment(item.registro, 'YYYY-MM-DD').format('dddd')] = item;
      }
      console.log('>>>', emptyData);

      for (const [key, value] of Object.entries(emptyData)) {
        data.push({
          name: key.charAt(0).toUpperCase() + key.slice(1),
          v: value ? value.valor : 0,
        });
      }
    }

    return data;
  }

  function dataMax(key) {
    let max = 0;
    if (props.data.hasOwnProperty(key)) {
      let arr = props.data[key].map(function (item) {
        return item.valor;
      });
      max = Math.max(...arr);
    }

    return max * 1.4;
  }

  function dataMin(key) {
    let min = 0;
    if (props.data.hasOwnProperty(key)) {
      let arr = props.data[key].map(function (item) {
        return item.valor;
      });
      min = Math.min(...arr);
    }

    return min * 1.4;
  }

  function labelFormatter(value) {
    let valueFormat = value;
    if (checkObjectKey(props.data, 'resultsByDay')) {
      valueFormat = formatterMetrico(
        value,
        props.data.resultsByDay.valor_formato
      );
    }

    return valueFormat;
  }

  return (
    <div>
      <Row gutter={32}>
        <Col
          span={9}
          onClick={props.openDataTable}
          style={{ cursor: 'pointer' }}
        >
          <Card>
            <div style={{ fontSize: '16px' }}>Cierre al dia de ayer </div>
            <div style={{ fontSize: '12px' }}>
              {moment().subtract(1, 'day').format('D MMMM, YYYY')}
            </div>
            <div style={{ fontSize: '40px', fontWeight: '500' }}>
              {checkObjectKey(props.data, 'resultsByDay')
                ? formatterMetrico(
                    props.data.resultsByDay.valor,
                    props.data.resultsByDay.valor_formato
                  )
                : ''}
            </div>
            <div style={{ display: 'flex' }}>
              <div style={{ fontSize: '16px' }}>
                Diferencia
                <font
                  style={{
                    fontSize: '16px',
                    fontWeight: '500',
                    marginLeft: '5px',
                  }}
                >
                  0 <font style={{ fontSize: '12px' }}>0%</font>{' '}
                  <CaretUpOutlined style={{ color: '#3DC65E' }} />
                </font>
              </div>
              <div style={{ fontSize: '16px', marginLeft: '5px' }}>
                Tendencia
                <font
                  style={{
                    fontSize: '16px',
                    fontWeight: '500',
                    marginLeft: '5px',
                  }}
                >
                  0 <font style={{ fontSize: '12px' }}>0%</font>{' '}
                  <CaretUpOutlined style={{ color: '#3DC65E' }} />
                </font>
              </div>
            </div>
          </Card>
        </Col>

        <Col span={15}>
          <div
            style={{ height: '180px', background: 'white', padding: '24px' }}
          >
            <div style={{ fontSize: '16px' }}>Semana {moment().isoWeek()}</div>
            <div style={{ fontSize: '12px' }}>{moment().format('YYYY')}</div>

            <ResponsiveContainer height={120}>
              <ComposedChart data={dataWeek()} allowDataOverFlow={true}>
                <XAxis dataKey="name" axisLine={false} />
                <YAxis
                  type="number"
                  domain={[dataMin('resultsByWeek'), dataMax('resultsByWeek')]}
                  hide
                />
                <Tooltip formatter={labelFormatter} />
                <Bar
                  isAnimationActive={false}
                  label={{ position: 'top', formatter: labelFormatter }}
                  name="Valor"
                  dataKey="v"
                  barSize={40}
                  fill="#413ea0"
                >
                  {dataWeek().map((entry, index) => (
                    <Cell key={index} fill={colorArray[index]} />
                  ))}
                </Bar>
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        </Col>
      </Row>

      <Row gutter={32} style={{ marginTop: '16px' }}>
        <Col span={24}>
          <div
            style={{
              height: '260px',
              marginTop: '16px',
              padding: '24px',
              background: 'white',
            }}
          >
            <div style={{ fontSize: '16px' }}>
              Mes {moment().format('MMMM')}
            </div>
            <div style={{ fontSize: '12px' }}>{moment().format('YYYY')}</div>
            <ResponsiveContainer height={180}>
              <ComposedChart allowDataOverFlow={true} data={dataMonth()}>
                <XAxis dataKey="name" tickLine={false} axisLine={false} />
                <YAxis
                  type="number"
                  domain={[
                    dataMin('resultsByMonth'),
                    dataMax('resultsByMonth'),
                  ]}
                  hide
                />
                <Tooltip formatter={labelFormatter} />
                <Area
                  allowDataOverFlow={true}
                  isAnimationActive={false}
                  isan
                  type="monotone"
                  dataKey="t"
                  name="Tendencia"
                  stroke="#82ca9d"
                  fill="#82ca9d"
                />
                <Line
                  isAnimationActive={false}
                  type="monotone"
                  dataKey="v"
                  stroke="blue"
                  name="Mes actual"
                  dot={null}
                  strokeWidth={2}
                />
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        </Col>
      </Row>

      <Row gutter={32}>
        <Col span={24}>
          <div
            style={{
              height: '260px',
              marginTop: '16px',
              marginBottom: '16px',
              padding: '24px',
              background: 'white',
            }}
          >
            <div style={{ fontSize: '16px' }}>Año</div>
            <div style={{ fontSize: '12px' }}>{moment().format('YYYY')}</div>
            <ResponsiveContainer height={180}>
              <ComposedChart allowDataOverFlow={true} data={dataYear()}>
                <XAxis dataKey="name" tickLine={false} axisLine={false} />
                <YAxis
                  type="number"
                  domain={[dataMin('resultsByYear'), dataMax('resultsByYear')]}
                  hide
                />
                <Tooltip formatter={labelFormatter} />
                <Line
                  isAnimationActive={false}
                  type="monotone"
                  dataKey="t"
                  stroke="#82ca9d"
                  name="Promedio de los ultimos 12 meses"
                  dot={null}
                  strokeWidth={2}
                />
                <Bar
                  isAnimationActive={false}
                  label={{ position: 'top', formatter: labelFormatter }}
                  name="Mes"
                  dataKey="v"
                  barSize={50}
                  fill="#413ea0"
                >
                  {dataYear().map((entry, index) => (
                    <Cell key={index} fill={colorArray[index]} />
                  ))}
                </Bar>
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Metrico;
